module.exports = __webpack_public_path__ + "img/img2.093f20f1.png";